import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';

import { AuthService } from '../core/auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Unlockdconfig } from '../../unlockd.config';
import { map } from 'rxjs/operators';
import { MiscHelperService } from './miscHelperService.service';
/**
 * Api services for the `Showings` model.
 */
@Injectable()
export class ShowingApi {
  constructor(
    protected http: HttpClient, 
    private authService: AuthService,
    private miscHelperService: MiscHelperService
    ) {}

  public createShowingAppointment(object, listing_id): Observable<any> {
    const { id } = this.authService.getAccessTokenInfo();
    object.claimer_id = id;

    const url = Unlockdconfig.getPath() + `/showings/${listing_id}/`;

    return this.http
      .post(url, object, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        )
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getShowingById(showing_id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/showings/${showing_id}`;

    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }
  public getAllAdminShowings(query_params): Observable<any> {
    const params = this.miscHelperService.objectToHttpParams(query_params);
    const url = Unlockdconfig.getPath() + `/admin/showings`;

    return this.http.get(url, {
      params: params,
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }
  public saveShowingAppointmentFeedback(
    showing_id,
    notification_id,
    object
  ): Observable<any> {
    const data = {
      feedback: true,
      showing_feedback: object,
      notification_id: notification_id
    };
    const url = Unlockdconfig.getPath() + `/showings/${showing_id}/feedback`;

    return this.http
      .post(url, data, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        )
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public acceptShowingAppointment(
    approval,
    showing_id,
    notification_id?,
    decline_reason?
  ): Observable<any> {
    const url = Unlockdconfig.getPath() + `/showings/${showing_id}/`;

    return this.http
      .put(
        url,
        { approval, notification_id, decline_reason },
        {
          headers: new HttpHeaders().set(
            'Authorization',
            this.authService.getAccessTokenId()
          )
        }
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  // The major difference between this and above is that this doesnot provide Notification ID

  public acceptShowingAppointmentById(
    approval,
    showing_id,
    decline_reason?
  ): Observable<any> {
    const url = Unlockdconfig.getPath() + `/showings/${showing_id}/`;

    return this.http
      .put(
        url,
        { approval, decline_reason },
        {
          headers: new HttpHeaders().set(
            'Authorization',
            this.authService.getAccessTokenId()
          )
        }
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getShowingAppointmentByListingId(listing_id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/showings/listings/${listing_id}`;

    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }

  public getShowingAppointmentByShowingId(showing_id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/showings/${showing_id}`;

    return this.http.get(url, {
      // headers: new HttpHeaders().set(
      //   'Authorization',
      //   this.authService.getAccessTokenId()
      // )
    });
  }

  public getShowingValidityForVideoCall(showing_id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/showings/${showing_id}/is_allowed`;

    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }
  public getShowingAppointmentByUserId(is_buyer = true): Observable<any> {
    // id
    const { id } = this.authService.getAccessTokenInfo();
    let url = Unlockdconfig.getPath() + `/showings/users/${id}`;
    // if (is_buyer) {
    //   url = Unlockdconfig.getPath() + `/showings/buyers/${id}`;
    // } else {
    //   url = Unlockdconfig.getPath() + `/showings/sellers/${id}`;
    // }

    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }

  public cancelShowingAppointmentById(id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/showings/${id}`;

    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }
}
